import { createRef } from 'react';

export const historyRef: any = createRef();

export const push = (name: String, params?: any) => {
  historyRef.current?.history?.push(name, params);
};

export const pushInNewTab = (path: string, params?: any) => {
  const url = params ? `${path}?${new URLSearchParams(params).toString()}` : path;
  window.open(url, '_blank');
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  historyRef,
  pushInNewTab,
  push
};
